<nz-modal
  nzWrapClassName="form-modal"
  [(nzVisible)]="isVisibleModal"
  [nzTitle]="modalTitle"
  [nzCentered]="true"
  [nzClosable]="true"
  [nzClassName]="'modal-m-t-30'"
  [nzContent]="modalContent"
  [nzFooter]="modalFooter"
  [nzMaskStyle]="{'background': 'rgba(255, 255, 255, 0.69)'}"
  (nzOnCancel)="onEmitCloseModal()">
  <ng-template #modalTitle>
    <div class="container-steps-modal" [@fadeInAnimation] *ngIf="appointment">
      <div class="header-modal">
        <h2 class="text-title-md-bold title-modal">Cita</h2>
        <div class="header-buttons" *ngIf="appointment.status !== appointmentStatusEnum.CANCELLED && appointment.status !==
          appointmentStatusEnum.COMPLETED && appointment.expert && (appointment.expert.available || appointment.expert.available === undefined)">
          <button
            (click)="onEmitRescheduleAppointment()"
            nz-button nzGhost nzType="primary">
            <i nz-icon nzType="clock-circle" nzTheme="outline"></i>
            Reprogramar cita</button>
          <button
            *ngIf="!isAppointmentCompleted"
            (click)="onEmitCancelAppointment()"
            nz-button nzGhost nzDanger nzType="primary">
            <i nz-icon nzType="close-circle" nzTheme="outline"></i>
            Cancelar cita</button>
        </div>
      </div>
      <p class="text-info mt-xxs">Información de la cita</p>
    </div>
  </ng-template>

  <ng-template #modalContent>
    <div class="container-modal" *ngIf="appointment && appointment.expert" [@fadeInAnimation]>
      <app-appointment-details
        [appointmentType]="appointment.type"
        [expertName]="appointment.expert.user.name + ' ' + appointment.expert.user.lastname"
        [expertSpeciality]="appointment.expert.specializationName"
        [location]="appointment.type === appointmentTypeEnum?.ON_SITE && appointment.clinicBranch ? appointment.clinicBranch?.address : null"
        [url]="appointment.meetUrl"
        [note]="appointment.meetNote"
        [date]="(this.appointment.startDate.date | isToday) ? 'Hoy' : (this.appointment.startDate.date | date:'mediumDate')"
        [hourFrom]="(appointment.startDate.date | date:'h:mm a')"
        [hourTo]="(appointment.endDate.date | date:'h:mm a')"
        [duration]="appointment.duration"
        [branchName]="appointment.clinicBranch ? appointment.clinicBranch.name : ''"
        [cardStyles]="cardConsultationStyles"
        [totalAppointmentsInService]="this.appointment.metadata?.totalAppointmentsInService || 0"
      ></app-appointment-details> <!--[date]="(!isToday ? (this.appointment.startDate.date | date:'mediumDate') : 'Hoy')"-->

      <p class="title text-subtitle-bold-upper mt-xlg">Motivo de la cita</p>
      <p>{{ appointment.users[0]?.patientObjective || 'Sin motivo de la cita' }}</p>

      <p class="title text-subtitle-bold-upper mt-xlg">Objetivos clínicos de la cita</p>
      <div nz-row [nzGutter]="[0, 7]">
        <div nz-col *ngFor="let goal of appointment.users[0]?.clinicObjectives; index as i">
          <nz-tag class="tag" [style.background-color]="goal | setClinicalObjectiveColor">
            {{ goal.text }}
          </nz-tag>
        </div>
      </div>
      <p class="mb-xlg mt-xxs" *ngIf="!appointment.users[0]?.clinicObjectives || appointment.users[0]?.clinicObjectives.length === 0"> Sin objetivos
        clínicos.
      </p>

      <p class="title text-subtitle-bold-upper mt-xlg mb-xs">Pacientes</p>
      <div *ngIf="appointment.users?.length> 0" class="container-patients">
        <div *ngFor="let patient of appointment.users; index as i">
          <app-card-patient
            [cardStyles]="cardConsultationStyles"
            [ngClass]="{'mb-xlg': i <(appointment.users.length - 1), 'mb-none': i >= (appointment.users.length - 1)}"
            [name]="patient.name"
            [email]="patient.email"
            [gender]="patient.gender"
            [lastName]="patient.lastname"
            [imageProfile]="patient.profileImageURL"
            ></app-card-patient>
        </div>
      </div>
      <div class="d-flex mt-xlg mb-xs" nz-typography [nzType]="'danger'" *ngIf="appointment.expert && !appointment.expert.available">
        <p class="text-info">
          <i nz-icon nzType="info-circle" nzTheme="outline"></i>
          La opción para agendar citas se encuentra deshabilidata.
          <span class="text-link" (click)="onEmitGotoProfile()">quiero ir a configuración</span>
        </p>
      </div>
    </div>
  </ng-template>

  <ng-template #modalFooter>
    <div class="container-footer-modal" [@fadeInAnimation]>
      <button
        *ngIf="appointment.status !== appointmentStatusEnum.CANCELLED && !appTourService.tourMode"
        (click)="onEmitGoToConsultationPage(isAppointmentCompleted)"
        nz-button nzType="primary">
        <i nz-icon [nzType]="isAppointmentCompleted ? 'eye' : 'arrow-right'" nzTheme="outline"></i>
        {{ isAppointmentCompleted ? 'VER DETALLES' : 'INICIAR LA CITA' }}</button>
      <button
        *ngIf="appointment.status === appointmentStatusEnum.CANCELLED && appointment.expert && (appointment.expert.available ||
        appointment.expert.available === undefined)"
        (click)="onEmitRescheduleAppointment()"
        nz-button nzType="primary">
        <i nz-icon nzType="clock-circle" nzTheme="outline"></i>
        REPROGRAMAR CITA</button>
    </div>
  </ng-template>
</nz-modal>
